import { Combo, Override } from "@bryntum/schedulerpro";

// added override in bryntum 6.0.5 version
Override.apply(class {
  static target = {
    class: Combo,
    product: "schedulerpro"
  }

  // Patching as with in the editor View Manager when changing value in the WidgetColumn, it crashes on the console
  // as it try to call a function on source where source with WidgetColumns undefined
  // to fix this I added this line at top `params.source = this;`
  triggerFieldChange(params, trigger = true) {
    params.source = this; // swivuFix
    // following code copied from bryntum
    if (trigger) {
      this.trigger('change', params);
    }
    this.eachAncestor?.(ancestor => {
      ancestor.onFieldChange?.(params);
      // Stop going up when reaching an ancestor that isolates its fields
      if (ancestor.isolateFieldChange?.(this)) {
        return false;
      }
    });
  }
})
